import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);
Vue.config.devtools = true;

Vue.filter("currency", function(value) {
  if (isNaN(value)) return value;

  return Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR"
  }).format(value / 100);
});

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations
});
